import React, { useEffect, useState } from 'react';
import { Typography, CircularProgress, Box } from '@mui/material';
import OrderByOptionService from '../features/setting/orderByOption/OrderByOptionService';

/** Matches `order_by_options.value` for the Mercari Nate account row */
const MERCARI_NATE_VALUE = 'mercari-nate';

/**
 * When Order By is the mercari-nate option, shows JPY already used in the current
 * Thai service day (resets 02:00 Asia/Bangkok), aligned with backend routing.
 */
const OrderByMercariNateDailyUsageLabel = ({ orderByOptions, selectedOrderByOptionId }) => {
  const selected = orderByOptions?.find((o) => o.id === selectedOrderByOptionId);
  const show = Boolean(selected && selected.value === MERCARI_NATE_VALUE);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!show || selectedOrderByOptionId == null) {
      setData(null);
      setError(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(false);

    OrderByOptionService.getDailyUsageForOption(selectedOrderByOptionId)
      .then((res) => {
        if (!cancelled) setData(res.data);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [show, selectedOrderByOptionId]);

  if (!show) return null;

  const isMercariCap = selected?.orderByType === 'mercariAccount';
  const jpy =
    data?.relevantAmountJpy != null
      ? Math.round(Number(data.relevantAmountJpy)).toLocaleString()
      : null;

  return (
    <Box sx={{ mt: 0.5, pl: 0.25 }}>
      <Typography component="div" variant="caption" color="text.secondary">
        {loading && (
          <>
            <CircularProgress size={10} sx={{ mr: 0.75, verticalAlign: 'middle' }} />
            กำลังโหลดยอดวันนี้…
          </>
        )}
        {!loading && error && 'โหลดยอดรายวันไม่สำเร็จ'}
        {!loading && !error && data && (
          <>
            ยอดที่ใช้แล้ววันนี้
            {isMercariCap ? ' (Merpay ไม่รวม 7-Eleven)' : ''}
            {': '}
            <strong>¥{jpy}</strong>
          </>
        )}
      </Typography>
    </Box>
  );
};

export default OrderByMercariNateDailyUsageLabel;
